<template>
  <dashboard-layout>
    <div class="container-fluid">
      <div class="col-md-6">
      <router-link to="/netpay" class="icon text-gray-600">
      <i class="fas fa-arrow-left"></i> Back
      </router-link>
  </div>
      <div class="card shadow mb-4">
        <div class="card-body">
          <div class="col-md-6">
         
         <h6 class="m-0 font-weight-bold text-dark">All Reprocessed Transactions</h6><br>
       </div>
          <div class="card-body justify-content-between"> 
          
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="startDate">Start Date</label>
              <vue-date-picker v-model="startDate" id="startDate" placeholder="Select start date"></vue-date-picker>
            </div>
            <div class="col-md-6">
              <label for="endDate">End Date</label>
              <vue-date-picker v-model="endDate" id="endDate" placeholder="Select end date"></vue-date-picker>
            </div>
            <div class="col-md-6">
              <label for="searchInput">Payment Reference</label>
              <input v-model="paymentRef" type="text" class="form-control" id="searchInput" placeholder="Enter payment reference">
          </div>
          <br>

            <div class="col-md-12 mt-2">
             
              <button @click="fetchRecords" class="btn btn-dark">Fetch Records</button>
            </div>
          </div>

          <div v-if="isLoading" class="text-center">
          <i class="fas fa-spinner fa-spin fa-3x"></i> <!-- Loading icon -->
          <p>Fetching Records...</p>
        </div>

        <div v-else>
          <div class="card-body">
            <div class="table-responsive" v-if="reprocessedRecords.length > 0">
              <table class="table table-bordered" width="100%" cellspacing="0">
                <thead>
                  <tr>
                    <th>PaymentDate</th>
                    <th>Receipt/PaymentRef</th>
                    <th>Payer/CustomerID</th>
                    <th>MerchantReference</th>
                    <th>Invoice/TransactionRef</th>
                    <th>TotalAmount</th>
                    <th>Settlement_Status</th>
                  </tr>
                </thead>
                <tbody>
                 
                  <tr v-for="(record, index) in displayedData" :key="index">
                    <td>{{ record.RecordDate }}</td>
                    <td>{{ record.Receipt_Number }}</td>
                    <td>{{ record.Payer_Name }}</td>
                    <td>{{ record.Payment_Reference }}</td>
                    <td>{{ record.Invoice_Number }}</td>
                    <td>{{ formatAmount(record.Total_Amount) }}</td>
                    <td :style="getSettlementStatusStyle(record.SettlementStatus)">
                      <i v-if="Isloading === false" class="fas fa-spinner fa-spin" style="color: #333;"></i>
                    <i v-else-if="Isloading === true">{{ record.SettlementStatus }}</i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
            <div class="table-responsive" v-if="reprocessedRecords.length === 0">
              <center>No Record Found</center>
              </div>
              <br>
  
            <ul class="pagination">
              <li :class="{ 'disabled': pageNumber === 1 }">
                <a @click="pageNumber > 1 ? pageNumber-- : null">&laquo;</a>
              </li>
              <li v-for="pageNumber in totalPages" :key="pageNumber" :class="{ 'active-page': pageNumber === currentPage }">
                <a @click="changePage(pageNumber)" class="page-number">{{ pageNumber }}</a>
              </li>
              <li :class="{ 'disabled': currentPage === totalPages }">
                <a @click="pageNumber < totalPages ? pageNumber++ : null">&raquo;</a>
              </li>
            </ul>
          </div>
          
          </div>
        </div>
      </div>
    </div>
  </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/components/DashboardLayout.vue';
import axios from 'axios';




export default {
  name: 'view-reprocessed-records',

  components: {
    DashboardLayout,
  },

  data() {
    return {
      showSuccessMessage: false,
      errorMessage: '',
      reprocessedRecords: [], 
      startDate: null, 
      endDate: null,
      paymentRef: '',  
      currentPage: 1,
      pageSize: 4,  
      Isloading: false,
      isLoading: true,
    };
  },

  async created() {

    try{
   
    await this.fetchDefaultRecords();
    this.isLoading = false;
  }catch (error) {
        console.error(error);
        this.isLoading = false; 
        this.$toast.open({
        message: error,
        type: 'error',
        duration: 3000,
        });
        }
  },
  computed: {
  displayedData() {
  const start = (this.currentPage - 1) * this.pageSize;
  const end = start + this.pageSize;
  return this.reprocessedRecords.slice(start, end);
},
totalPages() {
  return Math.ceil(this.reprocessedRecords.length / this.pageSize);
},
},

  methods: {

    formatAmount(amount) {
   
    const amountWithDecimals = Number(amount) / 100;

    
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return formatter.format(amountWithDecimals);
  },

    changePage(pageNumber) {
  this.currentPage = pageNumber;
 
},
      async fetchDefaultRecords() {
        const token = sessionStorage.getItem('token');
try {

  this.errorMessage = ''; 
  const headers = {
  'Authorization': `Bearer ${token}`,
};


  const response = await axios.get(this.$config.GETREPROCESSEDRECORD_ENDPOINT,{headers});

  if (response.status === 200) {
 
    this.reprocessedRecords = response.data;

   
    for (let i = 0; i < this.reprocessedRecords.length; i++) {
      const merchantRef = this.reprocessedRecords[i].Payment_Reference; 
      const statusResponse = await axios.post(this.$config.CHECKSETTELEMTSTATUS_ENDPOINT, {
        MerchantRef: merchantRef,
      },{headers});
      this.reprocessedRecords[i].SettlementStatus = statusResponse.data.response;
      this.Isloading = true;
    }
  } else {
    this.errorMessage = 'Failed to fetch reprocessed records. Please contact the system administrator.';
  }
} catch (error) {
  console.error('Error fetching default records:', error);
  this.errorMessage = 'Failed to fetch reprocessed records. Please contact the system administrator.';
}
},


  async fetchRecords() {
    this.isLoading = true;
try {
  const token = sessionStorage.getItem('token');
  this.errorMessage = ''; 
  let url = '';
  const headers = {
  'Authorization': `Bearer ${token}`,
   };


  if (!this.startDate && !this.endDate && !this.paymentRef) {
    this.errorMessage = 'Please enter a date range (e.g., 2023-09-05 to 2023-09-06) or payment reference.';
    return;
  }

 
  if (this.startDate && this.endDate) {
  
    const startDateStr = this.startDate.toISOString().split('T')[0];
    const endDateStr = this.endDate.toISOString().split('T')[0];

    url = `${this.$config.GETREPROCESSEDRECORD_ENDPOINT}?startDate=${startDateStr}&endDate=${endDateStr}`;
  } else if (this.paymentRef) {
  
    url = `${this.$config.GETREPROCESSEDRECORD_ENDPOINT}?paymentReference=${this.paymentRef}`;
  }

  const response = await axios.get(url,{headers});

  if (response.status === 200) {
   
    this.isLoading = false;
    this.reprocessedRecords = response.data;

    
    for (let i = 0; i < this.reprocessedRecords.length; i++) {
      const merchantRef = this.reprocessedRecords[i].Payment_Reference; 

      try {
        const statusResponse = await axios.post(this.$config.CHECKSETTELEMTSTATUS_ENDPOINT, {
          MerchantRef: merchantRef,
        },{headers});
        this.isLoading = false;
        this.reprocessedRecords[i].SettlementStatus = statusResponse.data.response;
        this.Isloading = true;
      } catch (error) {
        console.error(`Error fetching Settlement Status for record with MerchantRef ${merchantRef}:`, error);
       
        this.reprocessedRecords[i].SettlementStatus = 'Error';
      }
    }
  } else {
    this.errorMessage = 'Failed to fetch reprocessed records. Please contact the system administrator.';
  }
} catch (error) {
  console.error('Error fetching reprocessed records:', error);
  this.errorMessage = 'Failed to fetch reprocessed records. Please contact the system administrator.';
}
},





    getSettlementStatusStyle(status) {
      let style = {
        color: 'black',
      }; 

      if (status === 'Settled') {
        style.color = 'green';
        style['font-weight'] = 'bold'; 
      } else if (status === 'Not Settled') {
        style.color = 'red';
        style['font-weight'] = 'bold'; 
      } else if (status === 'Settlement is still Processing') {
        style.color = 'purple';
        style['font-weight'] = 'bold'; 
      } else if (status === 'Reprocessed') {
        style.color = 'orange';
        style['font-weight'] = 'bold'; 
      }

      return style;
    },
  },
};
</script>

<style>
.custom-card {
  margin: 10px;
}

.custom-card-width {
  max-width: 900px;
  margin: 30px auto;
}
</style>
